export const getToken = () => localStorage.getItem("token");

export const getUser = () => {
  try {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
  } catch (err) {
    return null;
  }
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  window.location.href = "/login";
};